require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-eden-worthington-spektrum.json") })
        }
      }, "path---interview-eden-worthington-spektrum");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-eden-worthington-spektrum!./.cache/json/interview-eden-worthington-spektrum.json
// module id = 670
// module chunks = 231608221292675